var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_2429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8826 7.19834L18.9464 0H17.2725L11.139 6.25022L6.2401 0H0.589844L7.99788 9.45144L0.589844 17H2.26385L8.74106 10.3996L13.9146 17H19.5649L11.8821 7.19834H11.8826ZM9.58978 9.53471L8.83919 8.59356L2.86702 1.10472H5.4382L10.2578 7.14845L11.0084 8.0896L17.2733 15.9455H14.7021L9.58978 9.53507V9.53471Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_2429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.392,
    height: 17,
    fill: "white",
    transform: "translate(0.381836)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitter-white.f40df4b241696dff26aa100be4162b1c.svg";
export { ForwardRef as ReactComponent };